import {
  INICIALITZAR,
  OBTENIR_DADES_CREACIO_INDIVIDU
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const collectius = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`:
      return action.payload && action.payload.collectius
        ? action.payload.collectius
        : {};

    default:
      return state;
  }
};

export default collectius;

const totsCollectius = state => state.collectius;

export const getCollectius = state => {
  const collectius = totsCollectius(state);

  if (!collectius) {
    return null;
  }
  return collectius;
};
